
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('div', { 'className': 'halo-item' }, _createElement('div', {
                    'className': 'product-card layout-1',
                    'data-product-id': 'product-' + this.id,
                    'data-id': this.id
                }, _createElement('div', { 'className': 'product-image' }, _createElement('a', {
                    'className': 'product_wishlist wishlist',
                    'href': '#',
                    'aria-label': 'wishlist',
                    'data-icon-wishlist': true,
                    'data-product-handle': this.handle,
                    'data-id': this.id
                }, _createElement('svg', { 'className': 'icon' }, _createElement('use', { 'xlinkHref': '#icon-heart' }))), _createElement('div', { 'className': 'product_badges' }, !this.out_of_stock && this.on_sale ? _createElement('div', {
                    'className': 'badge sale-badge sale-badge-2',
                    'key': '441'
                }, '\n          -', this.calcDiscount(this.price, this.compare_at_price), '%\n        ') : null, this.out_of_stock ? _createElement('div', {
                    'className': 'badge soldOut-badge',
                    'key': '626'
                }, _translate(`product_out_of_stock`)) : null), _createElement('a', {
                    'className': 'product-link' + (this.image2 ? ' image-swap' : ''),
                    'href': window.Convermax.getProductUrl(this.url),
                    'aria-label': 'link'
                }, _createElement('img', {
                    'className': (this.image2 ? 'image-one ' : '') + 'lazyautosizes lazyloaded',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'onError': this.onImageError
                }), this.image2 ? _createElement('img', {
                    'className': 'image-two lazyautosizes lazyloaded',
                    'src': this.resizeImage(this.image2),
                    'onError': e => this.onImageError(e, 'image2'),
                    'key': '1093'
                }) : null), _createElement('div', { 'className': 'product-action' }, _createElement('a', {
                    'className': 'btn btn--secondary details-btn',
                    'href': window.Convermax.getProductUrl(this.url)
                }, _createElement('span', {}, 'Details')))), _createElement('div', { 'className': 'product-content' }, _createElement('div', { 'className': 'product-detail' }, _createElement('div', { 'className': 'product-vendor' }, _createElement('a', Object.assign({}, {
                    'href': this.vendor_url,
                    'title': this.removeHTML(this.vendor)
                }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } }))), _createElement('div', { 'className': 'product-title' }, _createElement('a', Object.assign({}, {
                    'href': window.Convermax.getProductUrl(this.url),
                    'aria-label': 'title'
                }, { dangerouslySetInnerHTML: { __html: typeof this.breakWordOnSlash(this.title) === 'undefined' ? '' : this.breakWordOnSlash(this.title) } }))), [_createElement('div', {
                        'className': 'stjr-product-rating',
                        'data-product-id': this.removeHTML(this.sku),
                        'data-group': 'item_group',
                        'data-group-value': this.id,
                        'key': '21200'
                    })], _createElement('div', { 'className': 'sticker-container' }, this.assembly_available ? _createElement('div', {
                    'className': 'sticker sticker-mobile sticker-assembly cm_mobile-hide',
                    'key': '2331'
                }) : null, this.fast_shipping ? _createElement('div', {
                    'className': 'sticker sticker-mobile sticker-fast-shipping cm_mobile-hide',
                    'key': '2443'
                }) : null), _createElement('div', { 'className': 'product-price' + (this.on_sale && !this.price_varies ? ' price--on-sale' : '') }, this.on_sale && !this.price_varies ? _createElement('span', {
                    'className': 'price-item price-item--regular',
                    'key': '2696'
                }, _createElement('s', { 'className': 'money' }, '\n              ', this.add_to_cart_qty ? `Set of ${ this.add_to_cart_qty }:
              ${ this.formatPrice(this.compare_at_price * parseInt(this.add_to_cart_qty)) }` : this.formatPrice(this.compare_at_price), '\n            ')) : null, _createElement('span', { 'className': 'price-item ' + (this.on_sale && !this.price_varies ? 'price-item--sale' : 'price-item--regular') }, _createElement('span', { 'className': 'money' }, '\n              ', this.add_to_cart_qty ? `Set of ${ this.add_to_cart_qty }: ${ this.formatPrice(this.price * parseInt(this.add_to_cart_qty)) }` : this.formatPrice(this.price), '\n            '))), this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '3507'
                }) : null, this.body_html && this.view === '1' ? _createElement('div', mergeProps({
                    'className': 'product-description',
                    'key': '3647'
                }, { dangerouslySetInnerHTML: { __html: typeof this.body_html === 'undefined' ? '' : this.body_html } })) : null), _createElement('div', { 'className': 'product-actions' }), _createElement('div', { 'className': 'sticker-container' }, this.assembly_available ? _createElement('div', {
                    'className': 'sticker sticker-assembly cm_desktop-hide',
                    'key': '3975'
                }) : null, this.fast_shipping ? _createElement('div', {
                    'className': 'sticker sticker-fast-shipping cm_desktop-hide',
                    'key': '4071'
                }) : null))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products container' }, _createElement('div', { 'className': 'section-header text-left cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []